var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.field)?_c(_vm.field.component,{ref:_vm.field.id,tag:"component",attrs:{"id":_vm.field.id,"props":_vm.field,"disabled":_vm.disabled},on:{"update":_vm.update}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }